export default {
  login: {
    method: 'post',
    url: '/api/login'
  },
  // 修改密码
  updatePassword: {
    method: 'put',
    url: '/api/updatePassword'
  },
  // 退出登录
  logout: {
    method: 'post',
    url: '/api/logout'
  },
  // 编辑员工
  updateStaff: {
    method: 'put',
    url: '/api/updateStaff'
  },
  // 创建员工
  createStaff: {
    method: 'post',
    url: '/api/createStaff'
  },
  // 删除员工
  deleteStaff: {
    method: 'delete',
    url: '/api/deleteStaff'
  },
  // 获取员工列表
  getStaffList: {
    method: 'get',
    url: '/api/getStaffList'
  }
}
